import store from "@/store/index.js";
import ClientServiceV2 from "@/services/ClientServiceV2";
import { authGuard } from "@/auth/authGuard";
import { lookupClientFields } from "@/utils/clientFields";

/**
 * Allows the dynamic data program builder only when `authGuard` lets the user in (the route's
 * `meta.permission` is `programs:create:program`) and the builder's client has
 * `dynamicDataProgramsEnabled`.
 *
 * The client is the one the builder works on: `?clientId` in edit mode, otherwise the
 * selected client. Like the programs screen, it always fetches the client, so a column toggled
 * since the dropdown was cached applies at once; the cache is only a fallback for a failed fetch.
 */
export const dynamicDataProgramBuilderGuard = (to, from, next) =>
  authGuard(to, from, async (redirect) => {
    if (redirect !== undefined) return next(redirect);

    const clientId = to.query?.clientId ?? store.state.globalClientId;
    const { dynamicDataProgramsEnabled } = await lookupClientFields(
      store.state,
      ["dynamicDataProgramsEnabled"],
      clientId,
      new ClientServiceV2(),
      { fresh: true }
    );
    return dynamicDataProgramsEnabled ? next() : next({ path: "/" });
  });
